import { useMemo } from 'react'
import useRouter from './useRouter'

export default function useIsMarketing() {
  const { location } = useRouter()
  return useMemo(() => !location.pathname.startsWith('/a/'), [location])
}
